import React from "react";
import moment from "moment";
import { BsClockFill, BsXCircleFill, BsCheckCircleFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import { FaRegCalendarDays } from "react-icons/fa6";

const TodayAppointments = ({ bookings = [] }) => {
  const now = moment();
  const today = moment().format("YYYY-MM-DD");

  console.log({ bookings });

  const appointmentsToday = bookings
    .filter((booking) => {
      const bookingMoment = moment(
        booking.selectedDateTime,
        "YYYY-MM-DD hh:mm A"
      );
      const appointmentDate = bookingMoment.format("YYYY-MM-DD");
      const hour = bookingMoment.hour();
      return appointmentDate === today && hour >= 9 && hour < 18;
    })
    .sort((a, b) => {
      const timeA = moment(a.selectedDateTime, "YYYY-MM-DD hh:mm A");
      const timeB = moment(b.selectedDateTime, "YYYY-MM-DD hh:mm A");
      return timeA - timeB;
    });

  const formattedAppointments = appointmentsToday.map((booking) => {
    const startTime = moment(booking.selectedDateTime, "YYYY-MM-DD hh:mm A");
    const endTime = startTime.clone().add(30, "minutes");

    const status = now.isAfter(endTime) ? "Completed" : "Upcoming";

    return {
      id: booking._id,
      time: startTime.format("hh:mm A"),
      from: startTime.format("hh:mm A"),
      to: endTime.format("hh:mm A"),
      status,
      user: {
        title:
          booking.user?.displayName ||
          booking.customer_info?.name ||
          "Unknown User",
        photo: booking.user?.photo || "/images/diamond_logo2.png",
      },
    };
  });

  return (
    <div className="bg-dry rounded-xl border-[1px] border-border p-5 xl:mt-6">
      {formattedAppointments.length === 0 && (
        <p className="text-textGray text-sm">No appointments today.</p>
      )}
      {formattedAppointments.map((appointment) => (
        <div
          key={appointment.id}
          className="grid grid-cols-12 gap-2 items-center mb-4"
        >
          <div className="col-span-3 text-[12px] font-light flex items-center gap-2 flex-wrap">
            <span className="text-textGray">{appointment.time}</span>
            <span
              className={`
          px-2 py-[2px] sm:px-3 sm:py-[3px]
          rounded-full
          text-[10px] sm:text-xs
          font-medium uppercase
          flex items-center gap-1
          ${
            appointment.status === "Upcoming"
              ? "bg-orange-500 text-white"
              : "bg-green-500 text-white"
          }
        `}
            >
              {appointment.status === "Upcoming" && (
                <FaRegCalendarDays className="text-[12px]" />
              )}
              {appointment.status === "Completed" && (
                <BsCheckCircleFill className="text-[12px]" />
              )}
              {appointment.status}
            </span>
          </div>
          <div className="flex-colo relative col-span-2">
            <hr className="w-[2px] h-20 bg-border" />
            <div
              className={`w-7 h-7 flex-colo text-sm bg-opacity-10 rounded-full absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2
                ${
                  appointment.status === "Upcoming"
                    ? "bg-orange-500 text-orange-500"
                    : "bg-green-500 text-green-500"
                }`}
            >
              {appointment.status === "Upcoming" && <FaRegCalendarDays />}
              {appointment.status === "Completed" && <BsClockFill />}
            </div>
          </div>
          <Link
            to={`/booking/preview/${appointment.id}`}
            className="flex gap-2 col-span-6"
          >
            <img
              src={appointment.user?.photo}
              alt={appointment.user?.title}
              className="w-8 h-8 rounded-full object-cover p-1"
            />
            <div className="flex flex-col gap-1">
              <h2 className="text-xs font-light text-text">
                {appointment.user?.title}
              </h2>
              <p className="text-[12px] font-light text-yellowlight">
                {appointment.from} - {appointment.to}
              </p>
            </div>
          </Link>
        </div>
      ))}
    </div>
  );
};

export default TodayAppointments;
